module.exports = __webpack_public_path__ + "static/img/Qobuz.5a37ade5.png";